import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Link, useLocation } from 'react-router-dom';

const useStyles = makeStyles()((theme) => ({
  root: {
    paddingTop: theme.spacing(0),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
}));

const TABS = [
  { title: 'Gerenciamento', link: '/clientes' },
  { title: 'Retornos', link: '/clientes/retornos' },
  { title: 'Sumidos', link: '/clientes/sumidos' },
  { title: 'Aniversários', link: '/clientes/aniversariantes' },
  { title: 'Unificar Contatos', link: '/clientes/unificar' },
];

// COMPONENT
const CustomerPageWrapper = ({ children, title }) => {
  const { classes } = useStyles();
  const location = useLocation();

  return (
    <div className={classes.root}>
      <Tabs value={`${location.pathname}`} indicatorColor="primary" textColor="primary">
        {TABS.map((tabInfo) => (
          <Tab
            key={tabInfo.title}
            label={tabInfo.title}
            component={Link}
            value={tabInfo.link}
            to={tabInfo.link}
          />
        ))}
      </Tabs>
      {children}
    </div>
  );
};

export default CustomerPageWrapper;
